import React from 'react'
import { Dialog, Button, Text, Flex, Content, Pane } from '@leverege/ui-elements'

import S from './AddDialog.css'

export default class AddDialog extends React.Component {

  constructor( props ) {
    super( props )
    this.state = { model : props.creator.create() }
  }

  static getDerivedStateFromProps( props, state ) {
    if ( props.show === false && props.creator ) {
      return { model : props.creator.create() }
    }
    return null
  }

  onChange = ( evt ) => { 
    this.setState( { model : evt.value } )
  }

  onCreate = ( item ) => {
    const { onCreate } = this.props
    if ( typeof onCreate === 'function' ) {
      onCreate( this.state.model )
    }
  }

  render() {
    const { title, editor : Editor, onClose, show } = this.props
    const { model } = this.state
    const footer = (
      <div className={S.footer}>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
        <Button variant="primary" onClick={this.onCreate}>Create</Button>
      </div>
    )
    return (
      <Dialog show={show} title={title} footer={footer} onClose={onClose}>
        <Editor value={model} onChange={this.onChange}/>
      </Dialog>
    )
  }
}
